var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div ng-if=\"!bb.current_item.move_done\">\n<div bb-item-details ng-init=\"confirm_move()\">\n&nbsp;\n</div>\n</div>\n";
var id1="public-booking/_templates/steps/check_move.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/_templates/steps/check_move.html
// module id = 406
// module chunks = 0